import React from 'react'
import {
  FreshdeskConnectorForm,
  FTPConnectorForm,
  GenericConnectorForm,
  JiraConnectorForm,
  SFTPConnectorForm,
  ShopifyConnectorForm,
  ZendeskConnectorForm,
  ShopwareConnectorForm,
  OpenAIConnectorForm,
  AzureOpenAIConnectorForm,
  PostgreSQLConnectorForm,
  SharepointConnectorForm,
  GoogleConnectorForm,
  AWSConnectorForm,
  AppStoreConnectConnectorForm,
  DropboxConnectorForm,
  GoogleGmailConnectorForm,
  GoogleSheetsConnectorForm,
  AmazonSPConnectorForm,
  EbayConnectorForm,
  MiraklConnectorForm,
} from '@knots/shared-frontend'
import type { Connector } from '@knots/api-sdk'
import Typography from '@/components/ui/Typography'

import './ConnectorForm.scss'
import { useConnectorCreatedAction, useConnectorFormProps } from './ConnectorForm.hooks'
import { ConnectorFormProps } from './ConnectorForm.types'

export const ConnectorForm = (props: ConnectorFormProps) => {
  useConnectorCreatedAction(props)
  const formProps = useConnectorFormProps(props)
  const editingConnector = props.connector?.id ? (props.connector as Connector) : undefined

  switch (props.connector.system) {
    case 'GENERIC':
      return (
        <GenericConnectorForm
          editingConnector={editingConnector}
          setEditedData={undefined}
          {...formProps}
        />
      )
    case 'ZENDESK':
      return <ZendeskConnectorForm {...formProps} />
    case 'FRESHDESK':
      return <FreshdeskConnectorForm {...formProps} />
    case 'SHOPIFY':
      return <ShopifyConnectorForm {...formProps} />
    case 'JIRA':
      return <JiraConnectorForm {...formProps} />
    case 'FTP':
      return <FTPConnectorForm {...formProps} />
    case 'SFTP':
      return <SFTPConnectorForm {...formProps} />
    case 'SHOPWARE_V5':
      return <ShopwareConnectorForm {...formProps} />
    case 'OPENAI':
      return <OpenAIConnectorForm {...formProps} />
    case 'AZURE':
      return <AzureOpenAIConnectorForm {...formProps} />
    case 'POSTGRESQL':
      return <PostgreSQLConnectorForm {...formProps} />
    case 'GOOGLE':
      return <GoogleConnectorForm {...formProps} />
    case 'SHAREPOINT':
      return <SharepointConnectorForm {...formProps} />
    case 'AWS':
      return <AWSConnectorForm {...formProps} />
    case 'APP_STORE_CONNECT':
      return <AppStoreConnectConnectorForm {...formProps} />
    case 'DROPBOX':
      return <DropboxConnectorForm {...formProps} />
    case 'GOOGLE_GMAIL':
      return <GoogleGmailConnectorForm {...formProps} editingConnector={editingConnector} />
    case 'GOOGLE_SHEETS':
      return <GoogleSheetsConnectorForm {...formProps} editingConnector={editingConnector} />
    case 'AMAZON_SP':
      return <AmazonSPConnectorForm {...formProps} editingConnector={editingConnector} />
    case 'EBAY':
      return <EbayConnectorForm {...formProps} />
    case 'MIRAKL':
      return <MiraklConnectorForm {...formProps} editingConnector={editingConnector} />
    case 'SHOPWARE_V6':
    case 'NOCONNECTOR':
    default:
      return <Typography>No form for {props.connector.system}</Typography>
  }
}
